import {useEffect, useRef} from 'react';
import window from 'global/window';

export const useWindowEvent = <T extends keyof WindowEventMap>(
	eventName: T,
	handler: (event: WindowEventMap[T]) => void,
	options?: AddEventListenerOptions,
	disabled?: boolean,
): void => {
	useEffect(() => {
		if (disabled) return;
		window.addEventListener(eventName, handler, options);
		return () => {
			window.removeEventListener(eventName, handler, options);
		};
	}, [eventName, handler, options, disabled]);
};

export default useWindowEvent;
